var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-user-change-nickname-component",
      on: { keyup: _vm.keymap },
    },
    [
      _c(
        "div",
        { staticClass: "room-user-change-nickname flex flex-col gap-y-3" },
        [
          _c(
            "div",
            { staticClass: "change-nickname-body flex flex-col gap-y-3" },
            [
              _c("div", { staticClass: "change-nickname-text-container" }, [
                _c("div", { staticClass: "change-nickname-text title" }, [
                  _vm._v(_vm._s(_vm.$t("chat.changeNickname"))),
                ]),
              ]),
              _c("GrmTextField", {
                ref: "nickname",
                attrs: { focus: "", value: _vm.nickname, maxlength: 25 },
                on: { input: _vm.onInputNickname },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "change-nickname-footer" }, [
            _c("ul", { staticClass: "button-list" }, [
              _c(
                "li",
                { staticClass: "button-item" },
                [
                  _c(
                    "VButton",
                    { staticClass: "cancel", on: { click: _vm.onClickCancel } },
                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                { staticClass: "button-item" },
                [
                  _c("VButton", { ref: "ok", on: { click: _vm.onClickOk } }, [
                    _vm._v(_vm._s(_vm.$t("common.confirm"))),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }